const focusNextElement = () => {
  let focussableElements =
    'input[type=text]:not([disabled]),input[type=password]:not([disabled]),input[type=checkbox]:not([disabled]),input[type=date]:not([disabled]),input[type=time]:not([disabled]),button.enterFocus,[tabindex]:not([disabled]):not([tabindex="-1"]):not([tabindex="0"])';

  if (document.activeElement) {
    let moduleContainerElement = findModuleParent(
      document.activeElement,
      "moduleContainer"
    );
    if (isEmpty(moduleContainerElement)) {
      return;
    }

    let focussable = Array.prototype.filter.call(
      moduleContainerElement.querySelectorAll(focussableElements),
      function (element) {
        //check for visibility while always include the current activeElement
        return (
          element.offsetWidth > 0 ||
          element.offsetHeight > 0 ||
          element === document.activeElement
        );
      }
    );

    let index = focussable.indexOf(document.activeElement);
    if (index > -1) {
      let nextElement = focussable[index + 1] || focussable[0];
      nextElement.focus();
    }
  }
};

const findModuleParent = (el, id) => {
  if (isEmpty(el)) return null;
  while (true) {
    el = el.parentElement;
    if (isEmpty(el)) return null;
    if (el.id === id) return el;
  }
};

const focusPreviousElement = () => {
  let focussableElements =
    'input[type=text]:not([disabled]),input[type=password]:not([disabled]),input[type=checkbox]:not([disabled]),input[type=date]:not([disabled]),input[type=time]:not([disabled]),button.enterFocus,[tabindex]:not([disabled]):not([tabindex="-1"]):not([tabindex="0"])';

  if (document.activeElement) {
    let moduleContainerElement = findModuleParent(
      document.activeElement,
      "moduleContainer"
    );
    if (isEmpty(moduleContainerElement)) {
      return;
    }

    let focussable = Array.prototype.filter.call(
      moduleContainerElement.querySelectorAll(focussableElements),
      function (element) {
        //check for visibility while always include the current activeElement
        return (
          element.offsetWidth > 0 ||
          element.offsetHeight > 0 ||
          element === document.activeElement
        );
      }
    );

    let index = focussable.indexOf(document.activeElement);
    if (index > -1) {
      let nextElement = focussable[index - 1] || focussable[0];
      nextElement.focus();
    }
  }
};

const isEmpty = (value) => {
  return typeof value === "undefined" || value === null || value.length === 0;
};

const isEmptyArray = (value) => {
  return typeof value === "undefined" || value === null || value.length === 0;
};

const isEmptyString = (value) => {
  return (
    !value ||
    value == undefined ||
    value == null ||
    value == "" ||
    value.length == 0
  );
};

const toBoolean = (value) => {
  let finalValue = false;
  if (!isEmpty(value)) {
    if (value == "Y" || value == "TRUE" || value == "1") finalValue = true;
  } else finalValue = false;
  return finalValue;
};

const scrollToElement = (elementId, elementParentId) => {
  let element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }
};

const toInteger = (value) => {
  if (isEmpty(value)) {
    return 0;
  } else {
    return parseInt(value);
  }
};

const toDecimal = (value) => {
  if (isEmpty(value)) {
    return 0;
  } else {
    return parseFloat(value);
  }
};

const toCommaSeperatedAmount = (value) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
  });
  if (!isEmpty(value)) return formatter.format(value);
  else return parseFloat(0).toFixed(2);

  // if (!isEmpty(value)) return parseFloat(value).toLocaleString("en-US");
  // else return parseFloat(0).toFixed(2);
};

const customEventObject = (fieldName, selectedValue) => {
  return { target: { name: fieldName, value: selectedValue } };
};

const toRoundOffAmount = (value) => {
  /* convert it to 3 decimals and then round it off to 2 decimals */
  if (!isEmpty(value))
    return Math.round((Math.round(value * 1000) / 1000) * 100) / 100;
  else return parseFloat(0).toFixed(2);
};



const dateFormate = (value) => {
  if (value != null && value != undefined && value != "Invalid Date") {
    const today = new Date(value);
    const mm = today.getMonth() + 1; // getMonth() returns month index (0-11)
    const dd = today.getDate();
    const yyyy = today.getFullYear();
    const formattedDate = `${mm < 10 ? '0' + mm : mm}/${dd < 10 ? '0' + dd : dd}/${yyyy}`;
    return formattedDate;
  } else {
    return value;
  }
};

const toFormattedDate_v1 = (value) => {
  //return value.toString("yyyy-MM-ssThh:mm:ssZ");
  let result_value =  value.toISOString();
  console.log(result_value);
  return result_value;
  /*
  const tzname = "America/Los_Angeles";
  const longOffsetFormatter = new Intl.DateTimeFormat("en-US", {timeZone: tzname ,timeZoneName: "longOffset"});
  const longOffsetString = longOffsetFormatter.format(new Date(value)); // '2/28/2013, GMT-05:00'
  return longOffsetString;
  */
}

const toDownloadReportAddress = (
  fileName,
  isAttachment,
  mimeCheckRequired,
  reportURL) => {
  let address =
      reportURL + encodeURIComponent(fileName);

  if (isAttachment) {
    address += "&is_attachment=TRUE";
  }

  address += mimeCheckRequired
    ? "&mime_check_required=TRUE"
    : "&mime_check_required=FALSE";

  return address;
};

export {
  focusNextElement,
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toBoolean,
  scrollToElement,
  toInteger,
  toDecimal,
  toCommaSeperatedAmount,
  customEventObject,
  toRoundOffAmount,
  focusPreviousElement,
  dateFormate,
  toFormattedDate_v1,
  toDownloadReportAddress
};
